<template>
  <div class="home">  
    <div class="titleBox content" id="home">
      <img class="titleImg" src="@/assets/img/index/titleImg.png">
      <button @click="$emit('addTags', tags.popup ,'seePopup',true,null)">
      <img class="seePopup" src="@/assets/img/index/youtobePopup.png"></button>
      <img src="@/assets/img/index/youtobeTxt.png">
    </div>
    <div id="conduct" class="content slickBox lineDashed">
      <img class="illustrationImg" src="@/assets/img/index/slickImg.png">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">            
            <router-link :to="{path:'/detail', query:{obj: 'listPage',type:'hope'}}" @click="$emit('addTags',tags.hope,null,null,null)"><img src="@/assets/img/index/slider/3-1.png"></router-link>
            <h6>希望兒童合唱團</h6>
            <span>孩子們缺乏的不只是物資，也需要一份溫柔的陪伴與支持，用音樂帶領他們更自信地成長。
            </span>            
          </div>
          <div class="swiper-slide">          
            <router-link :to="{path:'/detail', query:{obj: 'listPage',type:'cat'}}" @click="$emit('addTags',tags.cat,null,null,null)"><img src="@/assets/img/index/slider/2-1.png"></router-link>
            <h6>台北市流浪貓保護協會</h6>
            <span>除了食物及住所，為浪浪和社區居民找到共存的平衡，是一份微小卻重要的關懷與溫柔。
            </span>
          </div>    
          <div class="swiper-slide">    
            <router-link :to="{path:'/detail', query:{obj: 'listPage',type:'home'}}" @click="$emit('addTags',tags.home,null,null,null)"><img src="@/assets/img/index/slider/1-1.png"></router-link>      
            <h6>家扶基金會 無窮世代計畫</h6>
            <span>只要多一點溫柔的觀察，就能從孩子不同興趣及學習能力裡，找到最適合他們的潛力。
              <!-- <span>看更多</span> -->
            </span>            
          </div>
         
        </div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-next"><img src="@/assets/img/index/slider/nextBT.png"></div>
      </div>
    </div>
    <div class="itemBox content">      
      <img class="illustrationImg" src="@/assets/img/index/itemImg.png">
      <div id="itemBox">
        <thisItem v-for="(item, key, index) in table.data" :item="item" :apiUrl="apiUrl" @gtag="$parent.gtag_trackEvent" />
      </div>      
      <router-link to="/listPage" class='btn' @click.native="$emit('addTags',tags.list,null,null,null)"><img src="@/assets/img/index/listBT.png"></router-link>
    </div>
    <div class="txtBox" id="GentleCarbon">
      <img src="@/assets/img/index/txt.png">
      <a class="btn" @click="$emit('addTags',tags.aeShop,'openAeShop',null,null)"><img src="@/assets/img/index/aeshop.png"></a>
    </div>
    <footerComponents></footerComponents>
    
    <popup :popupLocation="popupLocation" v-if="showPopup" @popupStatus="seePopup" />
  </div>
</template>

<!-- swiper -->
<script src="https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.1.0/js/swiper.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.1.0/js/swiper.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.1.0/js/swiper.esm.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.1.0/js/swiper.esm.bundle.js"></script>
<script>
  // @ is an alias to /src
  
  import footerComponents from '@/components/footerComponents.vue';
  import thisItem from '@/components/thisItem.vue';
  import popup from '@/components/popup.vue';
  import swal from 'sweetalert2';
  import axios from 'axios';


  export default {
    name: 'HomeView',
    props:['addTags','apiUrl'],
    components: {
      footerComponents,
      thisItem,
      popup,
    },
    data() {
      return {
        popupLocation: "youtoPopup",
        accessToken: '', //取得Line Token
        lineProfile: '', //取得user資訊
        showPopup: false,
        tags:{
          popup: '15268CCF90034B9894350D3C6C6AFF66',
          list:'DEE62BD8034640C29BF9D0D45FE14C5A',
          hope: 'E046E45C87CA4069BAD6C76470CFE208',
          cat: 'D2C28A7194214E59BEB154E962604B95',
          home: '7EB3F74EFB784FA69CF37EBDD148E198',
          aeShop: 'AD67A32F2EB74F5C9B1C835E6AC852AB'
        },
         table: {
          data: [],
          page: 0,
          totalPage: 0,
          params: {
            itemsPerPage: 2,
            page: 1,
            sortBy: ['created_time'],
            sortDesc: [true]
          }
        },
        url: {
          "getDataTableUrl": "API/GetDataTable/0A21BAD68D584873B29458D63ECF2988"
        }
      }
    },
    methods: {
      // youtobePopup
      seePopup(val) {
        if (val) {
          this.showPopup = true
        } else {
          this.showPopup = false
        }
      },
      openAeShop(){
        window.open("https://pse.is/4arlrm");
      },
      getTable(){
        var me =  this;
        var config = {
            method: "post",
            url: me.apiUrl + me.url.getDataTableUrl,
            data: me.table.params,
            headers: {"content-type": "application/json"}
        }
        swal.fire({allowOutsideClick:false});
        swal.showLoading();
        axios(config).then(res => {        
          var data = res.data;
          if(data && data.success){
              me.table.data = data.data;
              me.table.page = data.pageIndex;
              me.table.totalPage = data.totalPage;             
          }
        }).catch(() => {
            alert("系統忙碌中，請稍後再試");
        }).finally(() =>{
          swal.close();
        });
      },
    },
    created(){
      this.$childMethod.$on('seePopup',this.seePopup);
      this.$childMethod.$on('openAeShop',this.openAeShop);
      this.getTable()
    },
    mounted() {
      new Swiper('.swiper-container', {
        loop: true,
        spaceBetween: 10,
        slidesPerView: "auto",
        nextButton: '.swiper-button-next',
      });
    },
    destroyed(){
      this.$childMethod.$off('seePopup');
      this.$childMethod.$off('openAeShop');
    }
  }
</script>
<style lang="scss">
  .swiper-container {
    position: relative;
    width: 100%;
    height: 350px;
    overflow: inherit !important;
    margin-left: -10px!important;

    .swiper-button-next {
      background: none;
      right: -15px;
      width: 50px;
      top: 44%;
    }

    .swiper-pagination-bullet-active {
      background: var(--main);
    }

    h6,
    span {
      margin: 10px 15px 0 15px;
      line-height: 1.3;
    }

    h6 {
      font-size: 20px;
      color: #4d4d4d;
    }

    span {
      display: inline-block;
      color: #999;
      font-size: 13px;

      span {
        color: #f79949;
        margin: 0;
        text-decoration: underline;
        display: none;
      }
    }
  }
</style>